import React, { Component } from "react";
import * as ReactDOM from "react-dom";
import {
  Grid,
  GridColumn,
  GridDetailRow,
  GridToolbar,
} from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import { process } from "@progress/kendo-data-query";
//import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import {
  getManagedUserBySiteIdList,
  getManagedUserList,
} from "../../redux/actions/authActions";
import { Checkbox as ProgressCheckbox } from "@progress/kendo-react-inputs";
//Data

const EditCommandCell = (props) => {
  if (props.rowType === "groupHeader") {
    return null;
  }
  return (
    <td>
      <button
        className="k-button k-primary"
        onClick={() => props.enterEdit(props.dataItem)}
      >
        {props.displayName}
      </button>
    </td>
  );
};

const dataState = {
  sort: [{ field: "email", dir: "asc" }],
  take: 10,
  skip: 0,
  //group: [{ field: "" }],
};

class UserSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      instruments: [{}],
      dataState: dataState,
      openDeploymentForm: false,
      editItem: {},
      data: [],
      isSelectAll: true,
    };
  }

  enterEdit = (item) => {
    this.setState({
      openDeploymentForm: true,
      editItem: item,
      isEditMode: true,
      isNew: false,
    });
  };

  enterNew = () => {
    this.setState({
      openEditForm: true,
      isEditMode: false,
      editItem: {},
      isNew: true,
    });
  };

  enterDeployment = (item) => {
    this.setState({
      openDeploymentForm: true,
      editItem: item,
      isEditMode: true,
      isNew: false,
    });
  };

  handleSubmit = (event) => {};

  handleCancelEdit = (event) => {
    // //console.log(
    //   "handleCancelEdit",
    //   this.props.instruments,
    //   this.state.instruments
    // );
  };

  MyEditCommandCell = (props) => (
    <EditCommandCell
      {...props}
      enterEdit={this.enterEdit}
      displayName={"Deployment"}
    />
  );

  MyCalibrationCommandCell = (props) => (
    <EditCommandCell
      {...props}
      enterEdit={this.enterCalibration}
      displayName={"Calibration"}
    />
  );

  MyDetailRow = (props) => (
    <div>
      <div></div>
    </div>
  );

  componentDidMount() {
    if (this.props.isEnterpriseSearch) {
      this.props.getManagedUserList();
    } else {
      this.props.getManagedUserBySiteIdList(this.props.siteId);
    }
  }

  componentWillUnmount() {
    //if (this.props.isSelectAllUsers) {
    //console.log("componentWillUnmount", this.props.isSelectAllUsers);
    this.setState({ isSelectAll: true });
    //}
  }

  itemChange = (e) => {
    //console.log("itemChange", e);

    e.dataItem[e.field] = e.value;
    e.dataItem[e.field] = e.value;
    const data = this.state.data.map((item) =>
      item.email === e.dataItem.email ? e.dataItem : item
    );
    this.setState({ data });
    let enabled = [];
    data.map((d) => {
      if (d.enabled) {
        enabled = [...enabled, d];
      }
    });
    this.props.updateSelectedUsers(enabled);
  };
  dataStateChange = (e) => {
    this.setState({
      ...this.state,
      dataState: e.dataState,
    });
  };

  expandChange = (event) => {
    //TODO: If you want the expanded state to be preserved the dataItem.expanded value must be set to the returned data.
    // Consider a state array of expanded dataItem keys.
    event.dataItem.expanded = !event.dataItem.expanded;
    //this.props.this.forceUpdate();
    this.forceUpdate();
  };

  selectAllUsers = (event) => {
    this.setState({ isSelectAll: !this.state.isSelectAll });
    let data = this.state.data;
    data.map((item) => (item.enabled = event.target.checked));
    this.setState({ data });
    let enabled = [];

    this.props.updateSelectedUsers(event.target.checked ? data : enabled);
  };

  render() {
    let gridComponent;
    let data = this.props.users;
    if (this.props.users && !this.props.loading) {
      if (data != this.props.users || this.state.data.length != data.length) {
        this.setState({
          data: this.props.users.map((user) =>
            Object.assign(
              {
                inEdit: true,
                enabled: this.props.selectedUsers?.some(
                  (u) => u.email === user.email
                ),
              },
              user
            )
          ),
        });
      }

      gridComponent = (
        <Grid
          style={{ width: "800" }}
          //detail={InstrumentRangeSettings}
          //detail={DetailComponent}
          //detail={this.MyDetailRow}
          pageable
          sortable
          filterable={true}
          //groupable={true}
          resizable={true}
          reorderable={true}
          editField="inEdit"
          onItemChange={this.itemChange}
          data={process(this.state.data, this.state.dataState)}
          {...this.state.dataState}
          //expandField="expanded"
          //onExpandChange={this.expandChange}
          onDataStateChange={this.dataStateChange}
          dataItemKey={"email"}
        >
          <GridToolbar></GridToolbar>
          <GridColumn
            field="enabled"
            title={"enabled"}
            editor="boolean"
            width={120}
          />
          <GridColumn field="fullName" title={"Name"} editable={false} />
          <GridColumn field="email" title={"Email"} editable={false} />
        </Grid>
      );
    }

    if (
      (this.props.selectedUsers?.length != this.state.data.length) ==
        this.state.isSelectAll ||
      (this.props.selectedUsers?.length === this.state.data.length) !=
        this.state.isSelectAll
    ) {
      this.setState({
        isSelectAll:
          this.props.selectedUsers?.length === this.state.data.length,
      });
    }
    if (this.props.isSelectAllUsers && this.state.isSelectAll == null) {
      //console.log("isSelectAllUsers", this.props.isSelectAllUsers);
      this.setState({ isSelectAll: true });
    }

    return (
      <React.Fragment>
        <div className={"pg-checkbox"}>
          <ProgressCheckbox
            //style={{ transform: "scale(1.7)", margin: "5px" }}
            //className={"k-checkbox"}
            onClick={this.selectAllUsers}
            //onLoad={this.selectAllUsers}
            label={"Select All Users"}
            value={this.state.isSelectAll}
            //defaultValue={true}
          />

          {/*Loads in the component after the props have rendered from the store*/}
          {gridComponent}
          {this.props.loading && (
            <div className="k-loading-mask">
              <span className="k-loading-text">Loading</span>
              <div className="k-loading-image"></div>
              <div className="k-loading-color"></div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.authReducer.pending,
    users: state.authReducer.users,
  };
};

const mapDispatchToProps = { getManagedUserList, getManagedUserBySiteIdList };
//export default Instruments;
export default connect(mapStateToProps, mapDispatchToProps)(UserSelection);
